import { MenuItem, type MenuItemProps } from "@mui/material";
import { styled, alpha, type Theme } from "@mui/material/styles";

type NavigationMenuItemProps = MenuItemProps & {
	dark?: boolean;
	to?: string;
};

const sharedStyles = (theme: Theme) => ({
	whiteSpace: "nowrap",
	fontSize: "1rem",

	paddingLeft: theme.spacing(2),
	paddingRight: theme.spacing(2),
});

const darkStyles = (theme: Theme) => ({
	color: theme.palette.common.white,
	borderBottom: "2px solid transparent",

	"&.active": {
		color: theme.palette.common.white,
		borderBottom: `2px solid ${theme.palette.common.white}`,
		backgroundColor: alpha(theme.palette.common.white, 0.12),
	},

	"&:hover": {
		color: theme.palette.common.white,
		backgroundColor: alpha(theme.palette.common.white, 0.12),
	},
});

const lightStyles = (theme: Theme) => ({
	color: theme.palette.text.disabled,
	borderBottom: "2px solid transparent",

	"&.active": {
		color: theme.palette.text.primary,
		borderBottom: `2px solid ${theme.palette.text.primary}`,
	},

	"&:hover": {
		color: theme.palette.text.primary,
	},
});

export type { NavigationMenuItemProps };

export const NavigationMenuItem = styled(MenuItem, {
	shouldForwardProp: (prop) => prop !== "dark",
})<NavigationMenuItemProps>(({ theme, dark = false }) => ({
	...sharedStyles(theme),
	...(dark === true ? darkStyles(theme) : lightStyles(theme)),
}));
